import { ReserveInfo } from '@/commonTypes';
import styles from './styles.module.css';
import { useLayoutContext } from '@/context/LayoutContext';
import { formatTehranPersianDate } from '@/functions/formatTehranPersianDate';
import PriceSection from '@/components/pages/wallet/WalletContent/WalletInfo/PriceSection';

const AppointmentSummary = ({ info, activeTime }: { info?: ReserveInfo; activeTime?: string }) => {
  const { editInfo } = useLayoutContext();
  return (
    <div className={styles.card} dir="rtl">
      <div className={styles.title}>خلاصهٔ نوبت</div>

      <div className={styles.content}>
        <div className={styles.row}>
          <span className={styles.label}>خدمت</span>
          <span className={styles.value}>
            {editInfo?.type == 'shop' ? info?.service?.title : editInfo?.item?.title}
          </span>
        </div>

        <div className={styles.row}>
          <span className={styles.label}>زمان</span>
          <span
            className={styles.value}
          >{`${formatTehranPersianDate(info?.date, false)}  - ${activeTime}`}</span>
        </div>

        <div className={styles.row}>
          <span className={styles.label}>هزینهٔ خدمت</span>
          {/* <span className={`${styles.value} ${styles.price}`}>۶۰۰,۰۰۰</span> */}
          <PriceSection
            className={`${styles.value} ${styles.price}`}
            value={editInfo?.item?.price}
          />
        </div>

        <div className={styles.divider} />

        <div className={styles.depositRow}>
          <span className={styles.depositLabel}>بیعانهٔ قابل پرداخت</span>

          {/* <span className={styles.depositAmount}>
            ۱۸۰,۰۰۰ <span className={styles.currency}>تومان</span>
          </span> */}
          <PriceSection value="180000" className={`${styles.depositAmount}`} />
        </div>

        <div className={styles.note}>
          مابقی مبلغ (۴۲۰,۰۰۰ تومان) هنگام تحویل خودرو پرداخت می‌شود.
        </div>
      </div>
    </div>
  );
};

export default AppointmentSummary;
